import type { UseCase } from '../data/useCases';
import { useCaseAssets } from '../data/websiteAssets';
import { useI18n } from '../i18n/useI18n';

export function UseCaseCard({ item }: { item: UseCase }) {
  const { t } = useI18n();
  const Icon = item.icon;
  const image = useCaseAssets[item.id];

  return (
    <article className="info-card use-case-card">
      {image ? (
        <picture className="card-visual">
          <source srcSet={image.webp} type="image/webp" />
          <img src={image.png} alt={t(image.altKey)} loading="lazy" width="1448" height="1086" />
        </picture>
      ) : null}
      <div className="card-title-row">
        <Icon aria-hidden="true" size={24} />
        <h3>{t(item.titleKey)}</h3>
      </div>
      <p>{t(item.textKey)}</p>
    </article>
  );
}
